import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import ICOListing from './pages/ICOListing';
import ProjectDetail from './pages/ProjectDetail';
import Submit from './pages/Submit';
import VerifyEmail from './pages/VerifyEmail';
import Earn from './pages/Earn';
import EarnProject from './pages/EarnProject';
import TokenStudio from './pages/TokenStudio';

import Auth from './pages/Auth';
import VerifyAccount from './pages/VerifyAccount';
import { useAuth } from './context/AuthContext';
import Account from './pages/Account';
import EditProject from './pages/EditProject';
import Admin from './pages/Admin';

import Boost from './pages/Boost';
import AdminProjectPreview from './pages/AdminProjectPreview';
import ResetPassword from './pages/ResetPassword';
import ParticipantDashboard from './pages/ParticipantDashboard';
import Calendar from './pages/Calendar';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import Cookies from './pages/Cookies';
import Footer from './components/Footer';

function AppContent() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith('/admin');

  return (
    <>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/listings" element={<ICOListing />} />
        <Route path="/earn" element={<Earn />} />
        <Route path="/earn/:slug" element={<EarnProject />} />
        <Route path="/token-studio" element={<TokenStudio />} />
        <Route path="/:type/:slug" element={<ProjectDetail />} />
        <Route path="/add-crypto-project-ico" element={<Submit />} />
        <Route path="/connexion" element={<Auth />} />
        <Route path="/verifier-email" element={<VerifyEmail />} />
        <Route path="/verifier-email-compte" element={<VerifyAccount />} />

        <Route path="/mon-compte" element={<Account />} />
        <Route path="/edit/:slug" element={<EditProject />} />

        <Route path="/admin" element={<Admin />} />
        <Route path="/admin/:tabSlug" element={<Admin />} />

        <Route path="/admin/projet/:id" element={<AdminProjectPreview />} />

        <Route path="/boost/:slug" element={<Boost />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/calendar" element={<Calendar />} />
        <Route path="/mon-espace" element={<ParticipantDashboard />} />
        <Route path="/terms"   element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/cookies" element={<Cookies />} />
      </Routes>
      {!isAdmin && <Footer />}
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;